import { Entity } from '@adornis/baseql/decorators.js';
import { Product } from './Product.js';

@Entity()
export class ProductCHF extends Product {
  public static override _class = 'ProductCHF';
}
